import React, { useEffect } from 'react';
import Hero3D from './components/Hero3D';
import Features from './components/Features';
import AboutStreaming from './components/AboutStreaming';
import Pricing from './components/Pricing';
import Reveal from './components/Reveal';
import GlowCard from './components/GlowCard';

const BackdropPlayIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
    <path d="M8 6.5V17.5L17 12L8 6.5Z" />
  </svg>
);

const BackdropWaveIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 10.5A11 11 0 0 1 20 10.5" />
    <path d="M7 13.5A7 7 0 0 1 17 13.5" />
    <path d="M10 16.5A3 3 0 0 1 14 16.5" />
  </svg>
);

const BackdropFilmIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="4" y="5" width="16" height="14" rx="2" />
    <circle cx="8" cy="9" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="8" cy="15" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="16" cy="9" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="16" cy="15" r="0.7" fill="currentColor" stroke="none" />
    <path d="M10.8 9.2V14.8L14.6 12L10.8 9.2Z" fill="currentColor" stroke="none" />
  </svg>
);

const StreamingBackdrop = () => (
  <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
    <div className="absolute -top-32 left-[15%] h-72 w-72 rounded-full bg-brand/15 blur-3xl" />
    <div className="absolute bottom-8 right-[10%] h-72 w-72 rounded-full bg-brand-soft/10 blur-3xl" />
    <div className="absolute inset-0 opacity-[0.07] [background-image:radial-gradient(circle_at_20px_20px,rgba(255,122,26,0.34)_1.2px,transparent_1.2px)] [background-size:70px_70px]" />

    <span className="absolute left-[8%] top-[34%] inline-flex h-9 w-9 items-center justify-center rounded-lg border border-brand/20 bg-black/30 text-brand/30">
      <BackdropPlayIcon />
    </span>
    <span className="absolute right-[8%] top-[46%] inline-flex h-9 w-9 items-center justify-center rounded-lg border border-brand/20 bg-black/30 text-brand/30">
      <BackdropWaveIcon />
    </span>
    <span className="absolute left-[16%] bottom-[16%] inline-flex h-9 w-9 items-center justify-center rounded-lg border border-brand/20 bg-black/30 text-brand/30">
      <BackdropFilmIcon />
    </span>
  </div>
);

function App() {
  useEffect(() => {
    const handlePointerMove = (event) => {
      document.documentElement.style.setProperty('--cursor-x', `${event.clientX}px`);
      document.documentElement.style.setProperty('--cursor-y', `${event.clientY}px`);
    };

    window.addEventListener('pointermove', handlePointerMove, { passive: true });
    return () => window.removeEventListener('pointermove', handlePointerMove);
  }, []);

  return (
    <div className="relative isolate min-h-screen bg-surface-900 font-body text-text-100">
      <StreamingBackdrop />
      <div className="cursor-spotlight" aria-hidden />

      <Reveal delay={20}>
        <Hero3D />
      </Reveal>
      <main>
        <Reveal delay={80}>
          <Features />
        </Reveal>
        <Reveal delay={130}>
          <AboutStreaming />
        </Reveal>
        <Reveal delay={170}>
          <Pricing />
        </Reveal>
      </main>

      <GlowCard as="footer" wallpaper={false} className="mt-8 border-t border-brand/20 bg-black/65 py-7 text-center">
        <p className="font-display text-2xl font-bold text-text-100">GORDITO TV STREAMING</p>
        <p className="mt-2 text-sm text-text-300">Contacto: +57 350 6026938</p>
        <p className="mt-1 text-xs tracking-wide text-text-300">
          Todos los derechos reservados - Gordito TV streaming
        </p>
      </GlowCard>
    </div>
  );
}

export default App;
